import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { pageHref, normalizeRoutePath } from '../seo-config.js';

const navigationItems = [
  {
    label: 'Services',
    href: '/#services',
    children: [
      { label: 'Aircon Installation', href: '/aircon-installation', route: true },
      { label: 'Aircon Repairs', href: '/aircon-repairs', route: true },
      { label: 'Aircon Servicing', href: '/aircon-servicing', route: true },
      { label: 'Aircon Regas', href: '/aircon-regas', route: true },
      { label: 'Commercial Aircon', href: '/commercial-aircon', route: true },
      { label: 'Emergency Repairs', href: '/emergency', route: true },
    ],
  },
  {
    label: 'Aircons',
    href: '/aircons',
    route: true,
  },
  {
    label: 'Areas We Serve',
    children: [
      { heading: 'City Bowl & CBD' },
      { label: 'Bo-Kaap', href: '/aircon-repair-bo-kaap', route: true },
      { label: "Devil's Peak Estate", href: '/aircon-repair-devils-peak-estate', route: true },
      { label: 'Gardens', href: '/aircon-repair-gardens', route: true },
      { label: 'Higgovale', href: '/aircon-repair-higgovale', route: true },
      { label: 'Kensington', href: '/aircons-installer-kensington', route: true },
      { label: 'Oranjezicht', href: '/aircon-repair-oranjezicht', route: true },
      { label: 'Tamboerskloof', href: '/aircon-repair-tamboerskloof', route: true },
      { label: 'V&A Waterfront', href: '/aircon-repair-v-a-waterfront', route: true },
      { label: 'Vredehoek', href: '/aircon-repair-vredehoek', route: true },
      { heading: 'Atlantic Seaboard' },
      { label: 'Avignon Estate, Hout Bay', href: '/aircon-repair-avignon-security-estate-hout-bay', route: true },
      { label: 'Bakoven', href: '/aircon-repair-bakoven', route: true },
      { label: 'Bantry Bay', href: '/aircon-repair-bantry-bay', route: true },
      { label: 'Bergendal Estate, Hout Bay', href: '/aircon-repair-bergendal-security-estate-hout-bay', route: true },
      { label: 'Camps Bay', href: '/aircons-installations-camps-bay', route: true },
      { label: 'Clifton', href: '/aircon-repair-clifton', route: true },
      { label: 'Fresnaye', href: '/aircon-repair-fresnaye', route: true },
      { label: 'Green Point', href: '/aircon-repair-green-point', route: true },
      { label: 'Hanging Meadows, Hout Bay', href: '/aircon-repair-hanging-meadows-security-estate-hout-bay', route: true },
      { label: 'Hout Bay', href: '/aircon-repair-hout-bay', route: true },
      { label: 'KenRock Estate, Hout Bay', href: '/aircon-repair-kenrock-security-estate-hout-bay', route: true },
      { label: 'Llandudno', href: '/aircon-repair-llandudno', route: true },
      { label: 'Mouille Point', href: '/aircon-repair-mouille-point', route: true },
      { label: 'Ruyteplaats, Hout Bay', href: '/aircon-repair-ruyteplaats-security-estate-hout-bay', route: true },
      { label: 'Sea Point', href: '/aircon-repair-sea-point', route: true },
      { label: 'Stoneybrook, Hout Bay', href: '/aircon-repair-stoneybrook-security-estate-hout-bay', route: true },
      { label: 'Three Anchor Bay', href: '/aircon-repair-three-anchor-bay', route: true },
      { label: 'Tierboskloof, Hout Bay', href: '/aircon-repair-tierboskloof-security-estate-hout-bay', route: true },
      { heading: 'Southern Suburbs' },
      { label: 'Alphen Estate, Constantia', href: '/aircon-repair-alphen-estate-constantia', route: true },
      { label: 'Bergvliet', href: '/aircon-repair-bergvliet', route: true },
      { label: 'Bishopscourt', href: '/aircon-repair-bishopscourt', route: true },
      { label: 'Claremont', href: '/aircon-repair-claremont', route: true },
      { label: 'Constantia', href: '/aircon-repair-constantia', route: true },
      { label: 'Dreyersdal, Bergvliet', href: '/aircon-repair-dreyersdal-bergvliet-area', route: true },
      { label: 'Grassy Park', href: '/aircons-installer-grassy-park', route: true },
      { label: 'High Constantia', href: '/aircon-repair-high-constantia-security-estate', route: true },
      { label: 'Kenilworth', href: '/aircon-repair-kenilworth', route: true },
      { label: 'Kirstenhof', href: '/aircon-repair-kirstenhof', route: true },
      { label: 'Lansdowne', href: '/aircons-installer-lansdowne', route: true },
      { label: 'Marina da Gama, Muizenberg', href: '/aircon-repair-marina-da-gama-muizenberg', route: true },
      { label: 'Meadowridge', href: '/aircons-installations-meadowridge', route: true },
      { label: 'Newlands', href: '/aircon-repair-newlands', route: true },
      { label: 'Pinelands', href: '/aircons-installations-pinelands', route: true },
      { label: 'Retreat', href: '/aircons-installer-retreat', route: true },
      { label: 'Ridgewood', href: '/aircons-installer-ridgewood', route: true },
      { label: 'Rondebosch', href: '/aircon-repair-rondebosch', route: true },
      { label: 'Rondebosch Oval', href: '/aircon-repair-rondebosch-oval-estate', route: true },
      { label: 'Silverhurst, Constantia', href: '/aircon-repair-silverhurst-security-estate-constantia', route: true },
      { label: 'Silvertree Estate, Tokai', href: '/aircon-repair-silvertree-estate-tokai', route: true },
      { label: 'Steenberg', href: '/aircon-repair-steenberg', route: true },
      { label: 'Stonehurst, Tokai', href: '/aircon-repair-stonehurst-security-estate-tokai', route: true },
      { label: 'Tokai', href: '/aircon-repair-tokai', route: true },
      { label: 'Wynberg', href: '/aircons-installation-wynberg', route: true },
      { label: 'Zwaanswyk', href: '/aircon-repair-zwaanswyk', route: true },
      { heading: 'Century City' },
      { label: 'Century City', href: '/aircon-repair-century-city', route: true },
      { label: 'Island Club', href: '/aircon-repair-island-club-century-city', route: true },
      { label: 'Knightsbridge', href: '/aircon-repair-knightsbridge-century-city', route: true },
      { heading: 'Northern Suburbs' },
      { label: 'Clara Anna Fontein, Durbanville', href: '/aircon-repair-clara-anna-fontein-durbanville', route: true },
      { label: 'Durbanville', href: '/aircons-installer-durbanville', route: true },
      { label: 'Graanendal, Durbanville', href: '/aircon-repair-graanendal-lifestyle-estate-durbanville', route: true },
      { label: 'Kuils River', href: '/aircons-installer-kuils-river', route: true },
      { label: 'Loevenstein', href: '/aircon-repair-loevenstein', route: true },
      { label: 'Monte Vista', href: '/aircons-installation-monte-vista', route: true },
      { label: 'Plattekloof', href: '/aircons-installations-platterkloof', route: true },
      { label: 'Sonstraal, Durbanville', href: '/aircon-repair-sonstraal-durbanville', route: true },
      { label: 'Sonstraal Heights, Durbanville', href: '/aircon-repair-sonstraal-heights-durbanville', route: true },
      { label: 'Welgemoed', href: '/aircon-repair-welgemoed', route: true },
      { heading: 'West Coast / Blouberg' },
      { label: 'Big Bay', href: '/aircon-repair-big-bay', route: true },
      { label: 'Bloubergstrand', href: '/aircon-repair-bloubergstrand', route: true },
      { label: 'Burgundy Estate', href: '/aircon-repair-burgundy-estate', route: true },
      { label: 'Edgemead', href: '/aircon-repair-edgemead', route: true },
      { label: 'Melkbosstrand', href: '/aircons-installer-melkbosstrand', route: true },
      { label: 'Milnerton', href: '/aircons-installation-milnerton', route: true },
      { label: 'Parklands', href: '/aircon-repair-parklands', route: true },
      { label: 'Sunningdale', href: '/aircon-repair-sunningdale', route: true },
      { label: 'Table View', href: '/aircons-installer-table-view', route: true },
      { heading: 'South Peninsula / False Bay' },
      { label: 'Capri Village, Fish Hoek', href: '/aircon-repair-capri-village-fish-hoek', route: true },
      { label: 'Clovelly', href: '/aircon-repair-clovelly', route: true },
      { label: 'De Goede Hoop, Noordhoek', href: '/aircon-repair-de-goede-hoop-security-estate-noordhoek', route: true },
      { label: 'Fish Hoek', href: '/aircons-installer-fish-hoek', route: true },
      { label: 'Glencairn', href: '/aircon-repair-glencairn', route: true },
      { label: 'Kalk Bay', href: '/aircon-repair-kalk-bay', route: true },
      { label: 'Kommetjie', href: '/aircons-installations-kommetjie', route: true },
      { label: 'Lake Michelle, Noordhoek', href: '/aircon-repair-lake-michelle-security-lifestyle-estate-noordhoek', route: true },
      { label: 'Muizenberg', href: '/aircon-repair-muizenberg', route: true },
      { label: 'Noordhoek', href: '/aircon-repair-noordhoek', route: true },
      { label: 'Plumstead', href: '/aircon-repair-plumstead', route: true },
      { label: 'Scarborough', href: '/aircon-repair-scarborough', route: true },
      { label: "Simon's Town", href: '/aircons-installer-simon-s-town', route: true },
      { label: 'St James', href: '/aircon-repair-st-james', route: true },
      { label: 'Strandfontein', href: '/aircons-installations-strandfontein', route: true },
      { heading: 'Helderberg' },
      { label: 'De Zalze Golf Estate', href: '/aircon-repair-de-zalze-golf-estate-somerset-west-stellenbosch-border', route: true },
      { label: 'Erinvale Golf Estate, Somerset West', href: '/aircon-repair-erinvale-golf-estate-somerset-west', route: true },
      { label: "Gordon's Bay", href: '/aircon-repair-gordons-bay', route: true },
      { label: 'Somerset West', href: '/aircon-repair-somerset-west', route: true },
      { heading: 'Cape Winelands' },
      { label: 'Franschhoek', href: '/aircon-repair-franschhoek', route: true },
      { label: 'Paarl', href: '/aircon-repair-paarl', route: true },
      { label: 'Stellenbosch', href: '/aircon-repair-stellenbosch', route: true },
      { label: 'Val de Vie Estate, Paarl', href: '/aircon-repair-val-de-vie-estate-paarl', route: true },
    ],
  },
  {
    label: 'About',
    href: '/about',
    route: true,
  },
  {
    label: 'Contact',
    href: '/contact',
    route: true,
  },
];

export default function HeroNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  // Determine email link target based on current page
  const getEmailLinkTarget = () => {
    const path = normalizeRoutePath(location.pathname);
    if (path === '/aircon-installation') return '/aircon-installation#booking-form';
    if (path === '/aircon-repairs') return '/aircon-repairs#booking-form';
    if (path === '/aircon-servicing') return '/aircon-servicing#booking-form';
    if (path === '/aircon-regas') return '/aircon-regas#booking-form';
    if (path === '/commercial-aircon') return '/commercial-aircon#booking-form';
    if (path === '/emergency') return '/emergency#booking-form';
    return '/contact#contact-form';
  };

  const handleEmailClick = (e) => {
    const target = pageHref(getEmailLinkTarget());
    const currentPath = location.pathname;
    const targetPath = target.split('#')[0];

    // If already on the target page, scroll to the element
    if (normalizeRoutePath(currentPath) === normalizeRoutePath(targetPath)) {
      e.preventDefault();
      const elementId = target.split('#')[1];
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <header className="studio-header" aria-label="Primary navigation">
        <div className="header-inner">
          <Link className="brand" to="/" aria-label="Aircons Cape Town home">
            <img src="/aircon-cape-town-logo.svg" alt="Aircons Cape Town" className="brand-logo" width="180" height="90" />
          </Link>

          <nav
            className={menuOpen ? 'desktop-nav is-open' : 'desktop-nav'}
            aria-label="Main menu"
          >
            {navigationItems.map((item) => (
              <div
                className="nav-item"
                key={item.label}
                onMouseEnter={() => setOpenDropdown(item.children ? item.label : null)}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                {item.route ? (
                  <Link
                    className="nav-link"
                    to={pageHref(item.href)}
                    onClick={() => setMenuOpen(false)}
                  >
                    <span>{item.label}</span>
                    {item.children && <span className="nav-caret" aria-hidden="true">▾</span>}
                  </Link>
                ) : item.href ? (
                  <a
                    className="nav-link"
                    href={item.href.startsWith('/#') && location.pathname === '/' ? item.href.slice(1) : item.href}
                    onClick={() => setMenuOpen(false)}
                  >
                    <span>{item.label}</span>
                    {item.children && <span className="nav-caret" aria-hidden="true">▾</span>}
                  </a>
                ) : (
                  <button
                    type="button"
                    className="nav-link"
                    aria-haspopup="true"
                    aria-expanded={openDropdown === item.label}
                  >
                    <span>{item.label}</span>
                    {item.children && <span className="nav-caret" aria-hidden="true">▾</span>}
                  </button>
                )}
                {item.children && openDropdown === item.label && (
                  <div className="nav-dropdown">
                    {item.children.map((child) => (
                      child.heading ? (
                        <p className="nav-dropdown-heading" key={`heading-${child.heading}`}>
                          {child.heading}
                        </p>
                      ) : child.route ? (
                        <Link
                          className="nav-dropdown-link"
                          to={pageHref(child.href)}
                          key={child.label}
                          onClick={() => setOpenDropdown(null)}
                        >
                          {child.label}
                        </Link>
                      ) : (
                        <a
                          className="nav-dropdown-link"
                          href={pageHref(child.href)}
                          key={child.label}
                          onClick={() => setOpenDropdown(null)}
                        >
                          {child.label}
                        </a>
                      )
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          <Link className="contact-link nav-email" to={pageHref(getEmailLinkTarget())} onClick={handleEmailClick}>
            <img src="/Whatsapp and Email U s/email us .svg" alt="" style={{ width: '26px', height: '26px' }} />
            <span>Email Us</span>
          </Link>

          <button
            className="menu-toggle"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="mobile-navigation"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        <nav
          id="mobile-navigation"
          className={menuOpen ? 'mobile-nav is-open' : 'mobile-nav'}
          aria-label="Mobile menu"
        >
          {navigationItems
            .map((item) => (
              <div key={`mobile-${item.label}`} className="mobile-nav-section">
                {item.children ? (
                  <>
                    <p className="mobile-section-heading">{item.label}</p>
                    <div className="mobile-submenu">
                      {item.children.map((child) => (
                        child.heading ? (
                          <p className="mobile-submenu-heading" key={`mobile-heading-${child.heading}`}>
                            {child.heading}
                          </p>
                        ) : child.route ? (
                          <Link
                            to={pageHref(child.href)}
                            key={`mobile-${child.label}`}
                            onClick={() => setMenuOpen(false)}
                          >
                            {child.label}
                          </Link>
                        ) : (
                          <a
                            href={pageHref(child.href)}
                            key={`mobile-${child.label}`}
                            onClick={() => setMenuOpen(false)}
                          >
                            {child.label}
                          </a>
                        )
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    {item.route ? (
                      <Link
                        className="mobile-nav-link"
                        to={pageHref(item.href)}
                        onClick={() => setMenuOpen(false)}
                      >
                        <span>{item.label}</span>
                      </Link>
                    ) : (
                      <a
                        className="mobile-nav-link"
                        href={pageHref(item.href)}
                        onClick={() => setMenuOpen(false)}
                      >
                        <span>{item.label}</span>
                      </a>
                    )}
                  </>
                )}
              </div>
            ))}
          <Link
            className="mobile-nav-quote"
            to={pageHref(getEmailLinkTarget())}
            onClick={(e) => {
              handleEmailClick(e);
              setMenuOpen(false);
            }}
          >
            <span>Get a Quote</span>
          </Link>
        </nav>
      </header>
      <style>{`
        .studio-header {
          --ink: #087cc1;
          --line: rgba(24, 80, 168, 0.2);
          width: 100%;
          min-height: 78px;
          background: #FFFFFF;
          color: var(--ink);
          font-family: 'Inter Tight', Arial, Helvetica, sans-serif;
          box-sizing: border-box;
          position: sticky;
          top: 0;
          z-index: 1000;
        }
        .studio-header *, .studio-header *::before, .studio-header *::after { box-sizing: border-box; }
        .header-inner {
          width: min(calc(100% - 48px), 1400px);
          margin-inline: auto;
          min-height: 78px;
          display: flex;
          align-items: center;
          gap: 24px;
        }
        .brand {
          min-width: 180px;
          display: inline-flex;
          align-items: center;
          color: var(--ink);
          text-decoration: none;
        }
        .brand-logo {
          height: 90px;
          width: auto;
          display: block;
          margin-top: 8px;
        }
        .desktop-nav {
          flex: 1;
          min-width: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
        }
        .nav-item {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .nav-link {
          min-height: 46px;
          padding: 16px 14px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          color: var(--ink);
          text-decoration: none;
          font-family: 'Roboto Mono', 'Courier New', monospace;
          font-size: 13px;
          line-height: 14px;
          text-transform: uppercase;
          white-space: nowrap;
          transition: color 160ms ease;
        }
        .nav-link span:first-child { position: relative; }
        .nav-link span:first-child::after {
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          margin-top: 5px;
          background: var(--ink);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 180ms ease;
        }
        .nav-link:hover span:first-child::after,
        .nav-link:focus-visible span:first-child::after { transform: scaleX(1); }
        button.nav-link {
          background: none;
          border: none;
          cursor: pointer;
          font-family: inherit;
        }
        .nav-caret {
          font-size: 9px;
          opacity: 0.6;
        }
        .nav-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          min-width: 200px;
          max-height: 75vh;
          overflow-y: auto;
          background: #F4E04D;
          border: 1px solid #2457D6;
          padding: 8px 0;
          z-index: 100;
          display: flex;
          flex-direction: column;
          box-shadow: 0 8px 24px -8px rgba(10, 31, 51, 0.12);
        }
        .nav-dropdown-heading {
          margin: 0;
          padding: 10px 20px 4px;
          color: rgba(11, 31, 51, 0.55);
          font-family: 'Roboto Mono', 'Courier New', monospace;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          white-space: nowrap;
        }
        .nav-dropdown-link {
          padding: 12px 20px;
          color: #0B1F33;
          text-decoration: none;
          font-family: 'Inter Tight', Arial, Helvetica, sans-serif;
          font-size: 14px;
          line-height: 18px;
          white-space: nowrap;
          transition: background-color 160ms ease, color 160ms ease;
        }
        .nav-dropdown-link:hover {
          background: rgba(36, 87, 214, 0.15);
          color: #2457D6;
        }
        .contact-link {
          height: 56px;
          width: 160px;
          padding: 0 20px;
          background: #087cc1;
          color: #FFFFFF;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: background 160ms ease, color 160ms ease;
        }
        .contact-link:hover,
        .contact-link:focus-visible { background: #066ba4; }
        .nav-email {
          height: 56px;
          width: 160px;
          padding: 0 20px;
          background: #087cc1;
          color: #FFFFFF;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          text-decoration: none;
          transition: background 160ms ease, color 160ms ease;
        }
        .nav-email:hover,
        .nav-email:focus-visible { background: #066ba4; color: #FFFFFF; }
        .menu-toggle, .mobile-nav { display: none; }
        .nav-link:focus-visible, .brand:focus-visible, .contact-link:focus-visible,
        .menu-toggle:focus-visible, .mobile-nav a:focus-visible {
          outline: 2px solid var(--ink);
          outline-offset: 3px;
        }
        @media (max-width: 1023px) {
          .header-inner { width: min(calc(100% - 40px), 1400px); }
        }
        @media (max-width: 820px) {
          .header-inner { width: min(calc(100% - 32px), 1400px); min-height: 68px; }
          .studio-header { min-height: 68px; border-bottom: 1px solid var(--line); }
          .desktop-nav, .header-inner > .contact-link { display: none; }
          .header-inner { justify-content: space-between; }
          .brand { min-width: 0; }
          .brand-logo { height: 68px; }
          .menu-toggle {
            width: 42px;
            height: 42px;
            padding: 0;
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 5px;
            border: 0;
            border-radius: 4px;
            background: #087cc1;
            cursor: pointer;
            position: relative;
            z-index: 1001;
            overflow: visible;
          }
          .menu-toggle span {
            width: 20px;
            height: 2px;
            display: block;
            background: #FFFFFF;
            border: 0;
            opacity: 1;
            position: relative;
            z-index: 1002;
            transition: transform 160ms ease, opacity 160ms ease;
          }
          .menu-toggle:hover { background: #066ba4; }
          .mobile-nav {
            display: none;
            position: fixed;
            top: 68px;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 8px 24px 24px;
            border-top: 1px solid rgba(24, 80, 168, 0.2);
            background: #FFFFFF;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            z-index: 999;
          }
          .mobile-nav.is-open { display: flex; flex-direction: column; }
          .mobile-nav-section { margin-bottom: 28px; }
          .mobile-nav-section:last-of-type { margin-bottom: 0; }
          .mobile-section-heading {
            margin: 0 0 4px;
            padding: 0;
            color: #0B1F33;
            font-family: 'Roboto Mono', 'Courier New', monospace;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
          .mobile-submenu {
            display: flex;
            flex-direction: column;
          }
          .mobile-submenu a {
            min-height: 48px;
            padding: 0 0 0 4px;
            display: flex;
            align-items: center;
            color: #087cc1;
            text-decoration: none;
            font-family: 'Inter Tight', Arial, Helvetica, sans-serif;
            font-size: 15px;
            line-height: 1.2;
            border-bottom: 1px solid rgba(24, 80, 168, 0.12);
            transition: color 160ms ease;
          }
          .mobile-submenu a:last-child { border-bottom: 0; }
          .mobile-submenu a:hover { color: #066ba4; }
          .mobile-submenu-heading {
            margin: 0;
            padding: 14px 0 4px 4px;
            color: rgba(11, 31, 51, 0.55);
            font-family: 'Roboto Mono', 'Courier New', monospace;
            font-size: 10px;
            font-weight: 600;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
          .mobile-nav-link {
            min-height: 48px;
            padding: 0 0 0 4px;
            display: flex;
            align-items: center;
            color: #087cc1;
            text-decoration: none;
            font-family: 'Inter Tight', Arial, Helvetica, sans-serif;
            font-size: 15px;
            line-height: 1.2;
            border-bottom: 1px solid rgba(24, 80, 168, 0.12);
            transition: color 160ms ease;
          }
          .mobile-nav-link:hover { color: #066ba4; }
          .mobile-nav-quote {
            margin-top: 24px;
            min-height: 52px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #087cc1;
            color: #FFFFFF;
            border: none;
            border-radius: 4px;
            font-family: 'Inter Tight', Arial, Helvetica, sans-serif;
            font-size: 16px;
            font-weight: 600;
            text-decoration: none;
            transition: background 160ms ease;
          }
          .mobile-nav-quote:hover { background: #066ba4; color: #FFFFFF; }
        }
      `}</style>
    </>
  );
}
